import { ExternalToast, toast as soonerToast } from 'sonner';
import React from 'react';
import Toast, { ToastType } from 'app/toast/Toast';

export default function toast(type: ToastType = 'success', title?: string, description?: string, data?: ExternalToast) {
    return soonerToast.custom((id) => <Toast id={id} type={type} title={title} description={description} />, {
        duration: 5000,
        ...data,
    });
}
